import { ITypedAPITarget, IAPITarget } from "network-stapler";
import { IProduct, IProductOptions, IConfiguratorGeneral, IZipZone } from "../Utils/Interface";
const configuratorGeneral = require("./Mockdata/configuratorGeneral.json");
const productById = require("./Mockdata/productById.json");
const getModulesByProductId = require("./Mockdata/getModulesByProductId.json");
const zipzone = require("./Mockdata/zipzones.json");

export const API = {
	getConfiguratorGeneral(langLocal: string): ITypedAPITarget<IConfiguratorGeneral> {
		return {
			url: `/wp-json/wp/v2/configurator/?lang=${langLocal}`,
			method: "GET",
			mockResponseJSON: () => {
				return configuratorGeneral;
			},
			parse: (result: any): IConfiguratorGeneral => {
				// format data
				return result as IConfiguratorGeneral;
			},
		};
	},

	getProductById(id: string): ITypedAPITarget<IProduct> {
		return {
			url: `/wp-json/wp/v2/products/${id}/`,
			method: "GET",
			mockResponseJSON: () => {
				return productById;
			},
			parse: (result: any): IProduct => {
				// format data
				return result as IProduct;
			},
		};
	},

	getModulesByProductId(id: string): ITypedAPITarget<IProductOptions> {
		return {
			url: `/wp-json/wp/v2/products/${id}/modules/`,
			method: "GET",
			mockResponseJSON: () => {
				return getModulesByProductId;
			},
			parse: (result: any): IProductOptions => {
				// format data
				return result as IProductOptions;
			},
		};
	},

	getZipZones(langLocal: string): ITypedAPITarget<Array<IZipZone>> {
		return {
			url: `/wp-json/wp/v2/zipzones/?lang=${langLocal}`,
			method: "GET",
			mockResponseJSON: () => {
				return zipzone;
			},
			parse: (result: any): Array<IZipZone> => {
				// format data
				return result as Array<IZipZone>;
			},
		};
	},

	sendConfiguratorToCF7(formId: string, data: FormData): IAPITarget {
		return {
			url: `/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback/`,
			method: "POST",
			body: data,
			encodeBody: (body) => {
				return body;
			}
		};
	},
};
